<template>
  <div class="menu-container" :class="{ mobile: device === 'mobile' }">
    <div class="first-menu">

      <menu-item :label="$t('powerpack.menu.downloads')" tooltip-key="tooltip_motor_download">
        <div
            @click="openBlueprintModal()"
            class="download"
            v-if="canShowModule(['mini_powerpack', 'workplace', 'open_frame', 'closed_frame', 'industrial'])"
        >
          <img :src="getImage('dl-icon.svg')" alt="schema" class="icon-download"/>
          <span>{{ $t('powerpack.fileMenu.schemaDownload') }}</span>
        </div>
        <div v-if="stepExists" @click="downloadStep()" class="download">
          <img :src="getImage('dl-icon.svg')" alt="schema" class="icon-download"/>
          <span>{{ $t('powerpack.fileMenu.stepDownload') }}</span>
        </div>
        <div
            v-for="file in files"
            :key="file.id"
        >
          <template v-if="isLoggedIn || magentoLoggedIn">
            <div @click="downloadFile(file.id)" class="download">
              <img :src="getImage('dl-icon.svg')" alt="schema" class="icon-download"/>
              <a class="download" :href="api + 'download-file/' + file.id" download>{{ getLabel(file) }}</a>
            </div>
          </template>
          <template v-else>
            <div @click="redirectToLoginUrl" class="download">
              <img :src="getImage('dl-icon.svg')" alt="schema" class="icon-download"/>
              <a class="download">{{ getLabel(file) }}</a>
            </div>
          </template>
        </div>
      </menu-item>

      <popup-blueprint
          v-if="blueprintModal"
          @close="blueprintModal = false"/>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import {mapActions, mapGetters, mapState} from "vuex";
import InputDropdown from "@/components/input/Dropdown.vue";
import MenuItem from "@/components/step2/menu/MenuItem.vue";
import Swal from "sweetalert2";
import PopupBlueprint from "@/components/popup/PopupBlueprint.vue";
import showModuleMixin from '../../mixins/showModuleMixin';

export default {
  name: "FileMenu",
  components: {PopupBlueprint, MenuItem, InputDropdown},

  data() {
    return {
      files: [],
      api: process.env.VUE_APP_API_URL,
      blueprintModal: false,
      stepExists: false,
    }
  },

  mixins: [showModuleMixin],

  methods: {
    ...mapActions({
      redirectToLoginUrl: 'auth/redirectToLoginUrl',
    }),
    getFiles() {
      if (!this.activeMotor || !this.activeMotor.id) {
        return;
      }

      axios.get(process.env.VUE_APP_API_URL + 'get-files/' + this.activeMotor.id, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
          .then((response) => {
            this.files = response.data;
          })
    },
    checkIfStepExists() {
      if (!this.activeMotor || !this.activeMotor.id) {
        return;
      }

      axios.get(process.env.VUE_APP_API_URL + 'check-step/' + this.activeMotor.id, {
        headers: {
          'Content-Type': 'application/json',
        }
      }).then((response) => {
        this.stepExists = response.data.stepExists;
      })
    },
    downloadFile(file_id) {
      axios.get(process.env.VUE_APP_API_URL + 'download-file/' + file_id, {
        headers: {
          'Content-Type': 'application/json',
        }
      })
          .then((response) => {
            let link = document.createElement('a');
            link.download = response.data.file.url
            link.href = response.data.path;
            link.click();
          })
    },
    downloadStep() {
      if (!this.checkLogin()) {
        return;
      }

      axios.post(process.env.VUE_APP_API_URL + 'download-step-file/', {
        motor_id: this.activeMotor.id,
        tank_id: this.activeTank ? this.activeTank.id : null,
        pump_id: this.activePump ? this.activePump.id : null,
        headers: {
          'Content-Type': 'application/json',
        }
      })
          .then((response) => {
            let link = document.createElement('a');
            link.download = response.data.file.step_file
            link.href = process.env.VUE_APP_STORAGE_URL + response.data.path;

            link.click();
          })
          .catch((e) => {
            if (e.response.data.errors.file) {
              Swal.fire({
                title: e.response.data.errors.file[0],
                text: '',
                icon: 'error',
                confirmButtonColor: '#3DB0C7',
              })
            }
          })
    },
    checkLogin() {
      if (!this.isLoggedIn) {
        Swal.fire({
          title: this.$t('auth.login.loginRequired'),
          text: this.$t('auth.login.loginRequiredText'),
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('auth.login.loginButton'),
          cancelButtonText: this.$t('auth.login.cancelButton'),
        }).then((result) => {
          if (result.value) {
            this.redirectToLoginUrl();
          }
        });

        return false;
      }

      return true;
    },
    openBlueprintModal() {
      if (!this.checkLogin()) {
        return;
      }

      this.blueprintModal = true;
    },
    getLabel(file) {
      switch (this.locale) {
        case 'nl':
          return file.label_nl;
        case 'en':
          return file.label_en;
        case 'de':
          return file.label_de;
        default:
          return file.label_nl;
      }
    }
  },

  computed: {
    ...mapState({
      motors: state => state.motors.all,
      motorId: state => state.build.motor,
      pumpIndex: state => state.build.pump,
      byPumpId: state => state.pumps.byId,
      tankIndex: state => state.build.tank,
      byTankId: state => state.tanks.byId,
      magentoLoggedIn: state => state.preference.magentoLoggedIn,
    }),
    ...mapGetters({
      device: 'getDevice',
      locale: 'preference/getLocale',
      isLoggedIn: 'auth/isLoggedIn',
    }),
    activeMotor() {
      for (const motor of this.motors) {
        if (motor.id === this.motorId) {
          return motor;
        }
      }
      return {name: 'not found', image: 'placeholder'};
    },
    activePump() {
      let id = this.pumpIndex > 0 ? this.pumpIndex : 1;
      return this.byPumpId[id];
    },
    activeTank() {
      let id = this.tankIndex > 0 ? this.tankIndex : 1;
      return this.byTankId[id];
    },
  },
  watch: {
    motorId:  {
      handler(){
        this.getFiles();
        this.checkIfStepExists();
      },
      immediate: true
    },
  },
}
</script>

<style scoped lang="scss">
.icon-download {
  margin-right: 1rem;
}

.download {
  text-decoration: none;
  color: black;
  font-size: 14px;
  opacity: 1;
  padding: 0;
  margin-bottom: 2px;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
